import React from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';

import { Animation } from './styled-components';

interface PageTransitionProps {
  id: string;
  children: React.ReactNode;
  duration?: number;
  timingFunction?: React.CSSProperties['transitionTimingFunction'];
}

export const PageTransition = ({ id, children, duration, timingFunction }: PageTransitionProps) => (
  <TransitionGroup>
    <Transition key={id} timeout={150} exit={false}>
      {state => (
        <Animation
          $state={state}
          $duration={duration}
          $timingFunction={timingFunction}
        >
          {children}
        </Animation>
      )}
    </Transition>
  </TransitionGroup>
);
